export default "__VITE_ASSET__B6jPcrr4__"